module.exports = __webpack_public_path__ + "img/img-chart-02.b5d50af1.png";